import { render, staticRenderFns } from "./PurchaseInvoice.vue?vue&type=template&id=6fde7072&scoped=true&"
import script from "./PurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoice.vue?vue&type=style&index=0&id=6fde7072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde7072",
  null
  
)

export default component.exports